export default __webpack_public_path__ + "assets/hero2.7e774c09.jpg";